// extracted by mini-css-extract-plugin
export var hero = "enterprisesHanded-module--hero--5rPZ4";
export var bg = "enterprisesHanded-module--bg--ETeQ5";
export var desktop = "enterprisesHanded-module--desktop--vGKnC";
export var mobile = "enterprisesHanded-module--mobile--AOh5e";
export var core = "enterprisesHanded-module--core--1YnRx";
export var item = "enterprisesHanded-module--item--bDzwW";
export var facade = "enterprisesHanded-module--facade--JcBSL";
export var img = "enterprisesHanded-module--img--zvrEU";
export var facadeTwo = "enterprisesHanded-module--facade-two--UXxOT";
export var description = "enterprisesHanded-module--description--j0kXm";
export var container = "enterprisesHanded-module--container--wLS-X";
export var descriptionContent = "enterprisesHanded-module--description-content--DGn6X";
export var info = "enterprisesHanded-module--info--gGszH";
export var largeImage = "enterprisesHanded-module--large-image--u6Hpc";
export var linkButton = "enterprisesHanded-module--linkButton--cQBNp";
export var gallery = "enterprisesHanded-module--gallery--GFZDC";